import { ChangeEventHandler, ReactNode } from "react";
import RadioButton from "@ingka/radio-button";
import "@ingka/forms/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaRadioButtonProps = {
  id: string;
  value?: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  name?: string;
  "data-testid"?: string;
  label?: ReactNode;
};

function FixaRadioButton(props: FixaRadioButtonProps) {
  return <RadioButton {...props} />;
}

export default FixaRadioButton;
